// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__item___J4B_m {
    display: flex;
    flex-direction: row;
    padding: 10px 20px 10px 20px;
}

.style__text___fhJjN {
    margin-left: 20px;
}

.style__item___J4B_m:hover {
    background-color: var(--hover-light-color);
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsItem/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB","sourcesContent":[".item {\n    display: flex;\n    flex-direction: row;\n    padding: 10px 20px 10px 20px;\n}\n\n.text {\n    margin-left: 20px;\n}\n\n.item:hover {\n    background-color: var(--hover-light-color);\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `style__item___J4B_m`,
	"text": `style__text___fhJjN`
};
export default ___CSS_LOADER_EXPORT___;
